<template>
  <div class="rounded-md border border-gray-400 bg-slate-50 px-4 py-2 text-base shadow-md">
    <div>
      <span class="font-medium">Nro. comprobante</span>:
      {{ comprobanteTerceros.comprobante.numero_comprobante }}
    </div>
    <div>
      <span class="font-medium">Monto</span>: {{ comprobanteTerceros.comprobante.monto | currency }}
    </div>
    <div>
      <span class="font-medium">Estado uso</span>:
      <span class="uppercase">{{ textoEstadoUso(comprobanteTerceros.uso.estado_id) }}</span>
    </div>
    <div>
      <span class="font-medium">Estado pago</span>:
      <span class="uppercase">{{ textoEstadoPago(comprobanteTerceros.pago.estado_id) }}</span>
    </div>
    <!-- <div v-if="!comprobantePago" class="text-red-500">
        No es posible marcar como devuelto un comprobante impago.
      </div>
      <div v-else-if="comprobanteUsado" class="text-red-500">
        No es posible marcar como devuelto un comprobante asociado a una factura.
      </div>
      <div v-else class="py-2 flex items-center">
        <button
          class="inline-flex items-center px-2 py-2 space-x-2 text-sm font-medium text-white uppercase transition duration-150 ease-in-out rounded-md focus:outline-none hover:bg-colescba-blue-600 bg-colescba-blue-500 focus:ring-1 focus:ring-offset-1 focus:ring-colescba-blue-500"
          @click="showConfirmModal = true"
          type="button"
        >
          <span v-if="comprobanteUsado">Anular uso y marcar como devuelto</span>
          <span>Marcar como devuelto</span>
        </button>
      </div>
      <ConfirmationModal
        :isOpen="showConfirmModal"
        @save="devolucionComprobante"
        @modal:cancel="showConfirmModal = false"
      >
        <span v-if="comprobanteUsado">Se anulará el uso del comprobante indicado y se marcará como devuelto.</span>
        <span>Se marcará como devuelto el comprobante indicado.</span>
      </ConfirmationModal> -->
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import { mapState, mapActions } from 'vuex'
import ConfirmationModal from '@/components/Core/ConfirmationModal'

export default {
  props: {
    comprobanteTerceros: { type: Object, required: true },
  },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      showConfirmModal: false,
    }
  },

  computed: {
    ...mapState({
      estadosUso: state => state.app.estadosUso,
      estadosPago: state => state.app.estadosPago,
    }),
    comprobantePago() {
      return this.comprobanteTerceros?.pago.estado_id == 'PAGO'
    },
    comprobanteUsado() {
      return this.comprobanteTerceros?.uso.estado_id == 'USADO'
    },
  },

  methods: {
    ...mapActions({
      fetchEstadosUso: 'app/fetchEstadosUso',
      fetchEstadosPago: 'app/fetchEstadosPago',
    }),
    textoEstadoUso(estadoId) {
      return this.estadosUso?.find(e => e.id.trim() == estadoId).descripcion
    },
    textoEstadoPago(estadoId) {
      return this.estadosPago?.find(e => e.id.trim() == estadoId).descripcion
    },
    async devolucionComprobante(done) {
      try {
        /*if(this.comprobanteUsado) {
          await this.portalPagos.patchUsoComprobante(
            this.user.cuitCuil.numero,
            this.comprobanteTerceros.comprobante.numero_comprobante,
            { uso_id: 'USO_ANULADO' }
          )
        }*/

        await this.portalPagos.patchPagoPorComprobante(
          this.user.cuitCuil.numero,
          this.comprobanteTerceros.comprobante.numero_comprobante,
          {
            pago_id: 'DEVUELTO',
            forma_pago_id: this.comprobanteTerceros.forma_pago_id,
          }
        )

        done()

        this.$toast.open({
          message: 'Se marcó como devuelto el comprobante indicado.',
          type: 'success',
          duration: 2500,
          dismissible: true,
        })

        this.showConfirmModal = false
        this.$emit('refresh')
      } catch (e) {
        console.log(e)
        done('Ocurrió un error al procesar la información.')
      }
    },
  },
}
</script>
